import {HttpClientEnhancer} from '../HttpClient';

export const withBaseUrl =
    (baseUrlString: string): HttpClientEnhancer =>
    http => {
        return (url, init) => http(joinPaths(baseUrlString, url), init);
    };

const joinPaths = (base: string, path: string) => {
    // prettier-ignore
    return `${
        base.at(-1) === '/' ? base.slice(0, -1) : base
    }/${
        path.at(0) === '/' ? path.slice(1) : path
    }`;
};

if (import.meta.vitest) {
    const {it, expect, describe} = import.meta.vitest;

    describe('network-facade/joinPaths()', () => {
        it('removes leading slash', () => {
            expect(joinPaths('api', '/v1')).toEqual('api/v1');
        });
        it('removes trailing slash', () => {
            expect(joinPaths('api/', 'v1')).toEqual('api/v1');
        });
        it('removes both slashes', () => {
            expect(joinPaths('api/', '/v1')).toEqual('api/v1');
        });
        it('inserts slash when needed', () => {
            expect(joinPaths('api', 'v1')).toEqual('api/v1');
        });
    });
}
